// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"0627b737","202":"735d3aac","402":"dabf6568","486":"30b65f0b","550":"8e8e2b63","640":"9756e2a5","799":"54cd5125"}[chunkId] + ".chunk.js";
};